<template>
  <div id="coupons" v-if="getEnums">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button round size="mini" icon="fas fa-plus" type="primary" @click="createRegisterForm()">{{ $t("registrationManagement.registrationForm.createForm") }}</el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.registrationforms.title") }}</h5>
              <span v-if="$store.state.registerform.registerFormList.length > 0" v-html="$t('totalContent', [$store.state.registerform.registerFormList.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/registration-management--how-to-use-registration-forms')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'refresh' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refresh" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.registerform.registerFormList.length > 0">
            <div class="custom-grid-table-header registration-forms-grid-template mt-3">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <span>{{ $t("registrationManagement.registrationForm.registerationForm") }}</span>
              <span>{{ $t("registrationManagement.registrationForm.packages") }}</span>
              <span>{{ $t("registrationManagement.registrationForm.view") }}</span>
              <span></span>
            </div>

            <draggable :list="registerFormList" class="registration-forms-container" handle=".el-icon-s-grid" tag="div" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
              <div class="item" v-for="item in registerFormList" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="content-inner">
                  <div>
                    <i class="el-icon-s-grid burger"></i>
                  </div>

                  <div class="registration-forms-item-title">
                    <div class="custom-label mb-0">
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <template v-if="item.enableRegistration != true">
                            <p>{{ $t("registrationManagement.registrationForm.registerationSpecialMsg") }}</p>
                          </template>

                          <template v-if="item.formRegistrationType == 0">
                            <p>{{ $t("registrationManagement.registrationForm.freeRegisteration") }}</p>
                          </template>

                          <template v-if="item.formRegistrationType == 1">
                            <p v-if="item.currency != null">{{ $t("registrationManagement.registrationForm.currency") }} {{ getEnumsDisplay('Currency', item.currency) }}</p>
                            <p>{{ $t("registrationManagement.registrationForm.onlinePayment") }} {{ item.onlinePayments == true ? $t("registrationManagement.registrationForm.on") : $t("registrationManagement.registrationForm.off") }}</p>
                            <p>{{ $t("registrationManagement.registrationForm.paymentBankTransfer") }} {{ item.wiredPayments == true ? $t("registrationManagement.registrationForm.on") : $t("registrationManagement.registrationForm.off") }}</p>
                          </template>
                        </div>
                        <span>
                          <b>{{ item.title }}</b>
                          <i class="el-icon-info" :style="item.enableRegistration != true ? 'color:#FF6565' : ''"></i>
                        </span>
                      </el-tooltip>
                    </div>
                    <span>{{ getEnumsDisplay("RegistrationFormLanguage", item.language) }}</span>
                  </div>

                  <div class="item-color-container">{{ item.packets.length }}</div>

                  <el-switch v-model="item.isActive" @change="statusChanged(item.id)"></el-switch>

                  <div class="action-btns">
                    <el-tooltip effect="dark" :content="$t('event.buttons.registerLink')" placement="top">
                      <el-button type="success" icon="fas fa-link" size="mini" @click="goRegisterForm(item.link)" circle></el-button>
                    </el-tooltip>
                    <!-- <el-button icon="el-icon-caret-right" circle size="mini" type="warning"></el-button> -->
                    <el-tooltip effect="dark" :content="$t('event.buttons.edit')" placement="top">
                      <el-button icon="fas fa-pen" circle size="mini" type="primary" @click="openRegisterForm(item.id)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.buttons.delete')" placement="top">
                      <el-popconfirm @confirm="deleteForm(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteItem-' + item.id" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-register-form-lottie'" :title="$t('event.menu.registrationforms.title')" @btnAdd="createRegisterForm()" @btnRefresh="refresh" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="registerNewForm" :title="formId != null ? $t('registrationManagement.registrationForm.editRegisterationForm') : $t('registrationManagement.registrationForm.addRegisterationForm')" class="xlarge" center modal-append-to-body destroy-on-close>
      <RegisterFormDialog :id="formId" v-if="registerNewForm" @closeDialog="registerNewForm = false" @deleteMe="deleteForm(formId)" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import RegistrationFormAddUpdate from "../../components/RegistrationFormAddUpdate";
import RegisterFormDialog from "../../components/register-form/registerFormDialog.vue";
import ExcelImport from "../../components/ExcelImport";
export default {
 metaInfo() {
    return {
      title: this.$t("eventPageTitle.registrationForms"),
    };
  },
  components: { RegistrationFormAddUpdate, ExcelImport, RegisterFormDialog, draggable },
  name: "RegistrationFormScreen",
  data() {
    return {
      loading: false,
      listShort: false,
      formId: null,
      registerNewForm: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "coupons",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    goRegisterForm(link) {
      window.open(link, "_blank");
    },
    developmentPhase() {
      this.$message.info("Development Phase");
    },
    async changeSort() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      this.listShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.registerform.registerFormList.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveRegistrationFormOrders", payload);
        await this.$store.dispatch("getRegisterForm");
        this.loading = false;
      }, 500);
    },
    async refresh() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "refresh";
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getRegisterForm");
        this.loading = false;
      }, 500);
    },
    async createRegisterForm() {
      var id = await this.$store.dispatch("createRegisterFormBase");
      this.formId = id;
      this.registerNewForm = true;
    },
    openRegisterForm(id) {
      this.formId = id;
      this.registerNewForm = true;
    },
    async deleteForm(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = id;
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteRegisterForm", id);
        this.registerNewForm = false;
        this.loading = false;
      }, 500);
    },
    async statusChangedEnable(id) {
      await this.$store.dispatch("toggleRegistrationFormEnable", id);
    },
    async statusChanged(id) {
      await this.$store.dispatch("toggleRegistrationFormActive", id);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getRegisterForm");
      this.loading = false;
    }, 500);
  },
  async created() {
    if (this.$route.query.orderNumber != null && this.$route.query.orderNumber != undefined) {
      var res = await this.$store.dispatch("testGetPaymentInfo", this.$route.query.orderNumber);
      this.$confirm(res.data.alert.message, res.data.data.bankName, {
        confirmButtonText: "Kapat",
        cancelButtonText: "Cancel",
        showCancelButton: false,
        showClose: false,
        type: res.data.alert.hasError ? "error" : "success"
      }).then(() => {
        window.history.pushState({}, document.title, "/" + this.$route.path);
      });
    }
    await this.$store.dispatch("getAutomatedMessagesList");
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    }
  }
};
</script>
<style lang="less">
.c-badge-gray {
  background-color: #eaeaea;
  font-weight: bold;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 8px;
  align-items: center;
}

.registration-forms-grid-template {
  grid-template-columns: 36px 1fr 90px 90px 105px;
}
.item-color-container {
  padding: 5px 10px;
  width: max-content;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  color: #505763;
  font-size: 13px;

  i {
    margin-right: 0.25rem;
    font-size: 14px;
    color: #292f3b;
    font-weight: 600;
  }
  &.pointer {
    cursor: pointer;
  }
}
.registration-forms-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    & > .content-inner {
      .action-btns {
        display: flex;
        flex-direction: row;
        gap: 0.3rem;
        .el-button {
          margin: 0;
        }
      }
      .registration-forms-date {
        display: flex;
        flex-direction: row;
        gap: 0.35rem;

        & > div {
          display: flex;
          flex-direction: row;
          gap: 0.35rem;
          align-items: center;
        }
        .start,
        .end {
          font-size: 13px;
          color: #505763;
          font-weight: 500;

          i {
            font-weight: bold;
            font-size: 14px;
            color: #292f3b;
            font-weight: 600;
          }
        }
      }

      .registration-forms-item-img-title {
        display: flex;
        gap: 1rem;
        font-weight: 500;
        align-items: center;
        .registration-forms-item-title {
          font-weight: bold;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        & > .img {
          border-radius: 8px;
          width: 112px;
          height: 50px;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
        }
      }

      display: grid;
      grid-template-columns: 36px 1fr 90px 90px 105px;
      gap: 0.5rem;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;
      & > div:last-child {
        justify-self: flex-end;
      }
    }
    .info {
      transition: all 0.5s ease-in-out;
      display: grid;
      padding: 10px;
      gap: 1rem;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }

    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/RegisterFormScreen.vue